module.exports = "<app-term-info-list></app-term-info-list>\r\n"